/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './Image';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type SwatchSettingsQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['String']>;
  locale?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type SwatchSettingsQuery = { __typename?: 'Query', swatchMapping?: { __typename?: 'SwatchMapping', swatches?: { __typename?: 'SwatchMappingSwatchesCollection', items: Array<{ __typename?: 'Swatch', colourName?: string | null, additionalColourNames?: Array<string | null> | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null };

export declare const swatchSettings: import("graphql").DocumentNode;

export const SwatchSettingsDocument = /*#__PURE__*/ `
    query swatchSettings($id: String = "2DO2iP1NwFPJk6lmaROANQ", $locale: String = "en-US") {
  swatchMapping(id: $id, locale: $locale) {
    swatches: swatchesCollection {
      items {
        image {
          ...ImageFragment
        }
        colourName
        additionalColourNames
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const useSwatchSettingsQuery = <
      TData = SwatchSettingsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: SwatchSettingsQueryVariables,
      options?: UseQueryOptions<SwatchSettingsQuery, TError, TData>
    ) =>
    useQuery<SwatchSettingsQuery, TError, TData>(
      variables === undefined ? ['swatchSettings'] : ['swatchSettings', variables],
      fetcher<SwatchSettingsQuery, SwatchSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, SwatchSettingsDocument, variables, options),
      options
    );

useSwatchSettingsQuery.getKey = (variables?: SwatchSettingsQueryVariables) => variables === undefined ? ['swatchSettings'] : ['swatchSettings', variables];
;

useSwatchSettingsQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables?: SwatchSettingsQueryVariables, options?: RequestInit['headers']) => fetcher<SwatchSettingsQuery, SwatchSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, SwatchSettingsDocument, variables, options);